(function(){
  "use strict";
  function onReady(fn){ if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }

  function replaceTextNode(root){
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    var pairs = [
      ['Quick Links','Enlaces rápidos'],
      ['Get Connected','Conectarse'],
      ['Newsletter','Promociones'],
      ['Subscribe','Suscribirme'],
      ['Customer Reviews','Reseñas de clientes'],
      ['Write a review','Escribir reseña'],
      ['No reviews yet','Aún no hay reseñas'],
      ['Be the first to write a review','Sé la primera persona en dejar una reseña'],
      ['Based on','Basado en'],
      ['Add a review','Escribir reseña'],
      ['Nootropic','Nootrópico'],
      ['Anadir al carrito','Agregar al carrito'],
      ['Anadido al carrito','Añadido al carrito'],
      ['Agregando...','Agregando…'],
      ['Envio discreto','Envío discreto'],
      ['Optimizacion','Optimización'],
      ['Guia','Guía'],
      ['Ver Catalogo','Ver catálogo']
    ];
    while((node = walker.nextNode())){
      var value = node.nodeValue;
      if(!value || !value.trim()) continue;
      var next = value;
      pairs.forEach(function(pair){
        next = next.replaceAll(pair[0], pair[1]);
      });
      if(next !== value) node.nodeValue = next;
    }
  }

  function replaceAttrs(){
    document.querySelectorAll('[placeholder],[aria-label],[title]').forEach(function(el){
      ['placeholder','aria-label','title'].forEach(function(attr){
        var v = el.getAttribute(attr);
        if(!v) return;
        v = v.replaceAll('Anadir','Agregar')
             .replaceAll('Anadido','Añadido')
             .replaceAll('Optimizacion','Optimización')
             .replaceAll('Guia','Guía');
        el.setAttribute(attr, v);
      });
    });
  }

  function cleanFooterNewsletter(){
    var btns = Array.from(document.querySelectorAll('button,input[type="submit"],a'));
    btns.forEach(function(el){
      var txt = (el.textContent || el.value || '').trim();
      if(txt === 'Subscribe') { if('value' in el) el.value = 'Suscribirme'; else el.textContent = 'Suscribirme'; }
    });
  }

  onReady(function(){
    replaceTextNode(document.body);
    replaceAttrs();
    cleanFooterNewsletter();
    var mo = new MutationObserver(function(){
      replaceTextNode(document.body);
      replaceAttrs();
      cleanFooterNewsletter();
    });
    mo.observe(document.documentElement, {childList:true, subtree:true});
  });
})();
